import React from "react";

const UserTablePagination = ({ pagination, onPageChange, loading }) => {
  const { currentPage, totalPages, totalElements, pageSize } = pagination;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 7;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 0; i < 5; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages - 1);
      } else if (currentPage >= totalPages - 4) {
        pages.push(0);
        pages.push("...");
        for (let i = totalPages - 5; i < totalPages; i++) pages.push(i);
      } else {
        pages.push(0);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages - 1);
      }
    }
    
    return pages;
  };

  const startItem = currentPage * pageSize + 1;
  const endItem = Math.min((currentPage + 1) * pageSize, totalElements);

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        <span>
          Showing {startItem} to {endItem} of {totalElements} users
        </span>
      </div>

      <div className="pagination-controls">
        <button
          className="pagination-btn"
          onClick={() => onPageChange(0)}
          disabled={currentPage === 0 || loading}
        >
          First
        </button>

        <button
          className="pagination-btn"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 0 || loading}
        >
          Previous
        </button>

        <div className="page-numbers">
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              className={`page-number ${page === currentPage ? 'active' : ''} ${page === "..." ? 'ellipsis' : ''}`}
              onClick={() => page !== "..." && onPageChange(page)}
              disabled={page === "..." || loading}
            >
              {page === "..." ? "..." : page + 1}
            </button>
          ))}
        </div>

        <button
          className="pagination-btn"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages - 1 || loading}
        >
          Next
        </button>

        <button
          className="pagination-btn"
          onClick={() => onPageChange(totalPages - 1)}
          disabled={currentPage >= totalPages - 1 || loading}
        >
          Last
        </button>
      </div>

      <div className="page-size-selector">
        <label>
          Items per page:
          <select
            value={pageSize}
            onChange={(e) => {
              // Call parent component to handle page size change
              // This should trigger a reload with new page size
              if (onPageChange) {
                onPageChange(0, parseInt(e.target.value));
              }
            }}
            disabled={loading}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </label>
      </div>
    </div>
  );
};

export default UserTablePagination;